export default __webpack_public_path__ + "static/media/more-options.27b23a1e.svg";